import { render, staticRenderFns } from "./IdentityVerificationSection.vue?vue&type=template&id=2cd53eb8&scoped=true&"
import script from "./IdentityVerificationSection.vue?vue&type=script&lang=js&"
export * from "./IdentityVerificationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd53eb8",
  null
  
)

export default component.exports